/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const ENIGMA: CommunityData = {
  code: "enigma",
  inviteCode: "enigma",
  name: "ENIGMA",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/eni-030`,
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "",
      hero: {
        desktop: "",
        mobile: "",
        style: "",
      },
      logo: {
        desktop: "",
        mobile: "",
        style: "",
      },
      werzLogoColor: "",
      title: "",
      text: "",
      button: "",
      input: {
        base: "",
        border: "",
        borderFocus: "",
        borderError: "",
        errorText: "",
      },
      error: "",
      footerText: "",
      skipButton: "",
      modal: {
        container: "",
        title: "",
        text: "",
        width: "",
        backdrop: "",
        otpInput: "",
        otpBorder: "",
        otpBorderFocus: "",
      },
    },
    global: {
      counterColor: "",
      logo: {
        src: "https://media.werz.at/community/icon/cmoi7x7nj00009kq4ae5mvpof.jpg?uploadTime=1777373377718&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "",
        styles: "",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "",
      asideBg: "",
      asideStyles: "",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "",
      primaryButton: "",
    },
    navigation: {
      iconsColor: "",
      sideBarSeparator: "",
      separator: "",
      item: "",
      itemSelected: "",
    },
    communityLanding: {
      container: "",
      titles: "",
      emptyOrLoadingState: "",
      announcementsV2: {
        sectionContainer: "",
        sectionTitle: "",
        scrollMenu: {
          container: "",
          wrapper: "",
          item: "",
        },
        item: {
          container: "",
          mediaContainer: "",
          media: "",
          placeholderMedia: "",
          content: "",
          title: "",
          subtitle: "",
        },
      },
      eventsV2: {
        sectionContainer: "",
        sectionTitle: "",
        scrollMenu: {
          container: "",
          wrapper: "",
          item: "",
        },
        item: {
          container: "",
          mediaContainer: "",
          media: "",
          placeholderMedia: "",
          content: "",
          title: "",
          subtitle: "",
          location: "",
          date: "",
        },
      },
      shop: {
        container: "",
        title: "",
        text: "",
        customShopImageStyle: "",
        sectionTitle: "",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile:
        "https://media.werz.at/community-assets/enigma/mobile-landing-background.mp4?type=video",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover",
        name: "text-[#b4da44] font-['FreeSansBold'] text-[28px] text-center text-center mt-4 mb-1",
        location: "font-['FreeSansBold'] text-[16px] text-center text-center mb-2",
        description:
          "text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#d5d5d5",
        button:
          "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff]",
          title: "font-['FreeSansBold'] text-[16px] text-left text-center mb-1",
          text: "text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center text-center",
          button:
            "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header: "text-[#b4da44] font-['FreeSansBold'] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] rounded-[16px]",
          duration: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          name: "text-[#8d8d8d] font-['FreeSansBold'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#d5d5d5",
          media: "overflow-hidden m-2 rounded-[16px]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] rounded-[16px]",
          name: "text-[#8d8d8d] font-['FreeSansBold'] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#ffffff00] rounded-[8px] text-[#000000] font-['FreeSansBold'] text-[16px] text-center",
          duration: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          location: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          button:
            "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container: "min-h-[68px] px-4 py-3 flex justify-between gap-4",
            name: "text-[#8d8d8d] font-['FreeSansBold'] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#8d8d8d] font-['FreeSansBold'] text-[14px] text-left",
            link: "text-[#8d8d8d] font-['FreeSansMedium'] text-[15px] leading-[20.25px] text-left",
            status: "text-[#8d8d8d] font-['FreeSansBold'] text-[14px] text-left",
            button:
              "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center",
        header: "text-[#b4da44] font-['FreeSansBold'] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] rounded-[16px]",
          name: "text-[#8d8d8d] font-['FreeSansBold'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#d5d5d5",
          created: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          media: "overflow-hidden m-2 rounded-[16px]",
        },
        seeAllNews:
          "text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center",
        header: "text-[#b4da44] font-['FreeSansBold'] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] rounded-[16px]",
          coverUrl: "overflow-hidden m-2 rounded-[16px]",
          duration: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          liveType: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#b4da44] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#b4da44",
          playIconBorderColor: "#000000",
          start: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
          title:
            "text-[#8d8d8d] font-['FreeSansBold'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] text-[#8d8d8d] font-['FreeSansMedium'] text-[17px] text-center",
        header: "text-[#b4da44] font-['FreeSansBold'] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] rounded-[16px]",
          name: "text-[#8d8d8d] font-['FreeSansBold'] text-[16px] text-left",
          triangleIconColor: "#d5d5d5",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover rounded-[16px]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#8d8d8d] font-['FreeSansMedium'] text-[14px] leading-[18.9px] text-left",
      },
    },
    eventV2: {
      container: "",
      eventInfo: {
        container: "",
        media: "",
        title: "",
        subtitle: "",
        button: "",
        questions: "",
      },
      about: {
        container: "",
        header: "",
        text: "",
      },
      location: {
        container: "",
        header: "",
        text: "",
        map: "",
        mapPinColor: "",
        mapStrokeColor: "",
      },
      downloadWERZ: {
        container: "",
        header: "",
        text: "",
      },
      tickets: {
        header: "",
        outerContainer: "",
        innerContainer: "",
        ticket: {
          container: "",
          mediaContainer: "",
          media: "",
          name: "",
          description: "",
          price: "",
          quantity: "",
          status: "",
          counterContainer: "",
          button: "",
          plusMinusColor: "",
        },
      },
    },
  },
}

export default ENIGMA
